/* eslint-disable react/prop-types */
import React from 'react';

import { Container } from './styles';

const ButtonBase = ({ children, variant, ...restProps }) => {
  return (
    <Container variant={variant}>
      <button type="button" {...restProps}>
        {children}
      </button>
    </Container>
  );
};

export default ButtonBase;
export { ButtonBase };
